import {DESIGN_WIDTH, DESIGN_HEIGHT} from '../const/index';

export const leftStar = {
    v: '5.9.0',
    fr: 25,
    ip: 25,
    op: 124,
    w: DESIGN_WIDTH,
    h: DESIGN_HEIGHT,
    nm: '星光闪烁_左',
    ddd: 0,
    assets: [],
    layers: [
        {
            ddd: 0,
            ind: 1,
            ty: 4,
            nm: '形状图层 1',
            sr: 1,
            ks: {
                o: {a: 0, k: 100, ix: 11},
                r: {a: 0, k: 0, ix: 10},
                p: {a: 0, k: [372.09, 207.84, 0], ix: 2, l: 2},
                a: {a: 0, k: [-543.91, -342.16, 0], ix: 1, l: 2},
                s: {
                    a: 1,
                    k: [
                        {
                            i: {x: [0.667, 0.667, 0.667], y: [1, 1, 1]},
                            o: {x: [0.333, 0.333, 0.333], y: [0, 0, 0]},
                            t: 25,
                            s: [20, 20, 100],
                        },
                        {
                            i: {x: [0.667, 0.667, 0.667], y: [1, 1, 1]},
                            o: {x: [0.333, 0.333, 0.333], y: [0, 0, 0]},
                            t: 35,
                            s: [100, 100, 100],
                        },
                        {t: 75, s: [20, 20, 100]},
                    ],
                    ix: 6,
                    l: 2,
                },
            },
            ao: 0,
            ef: [
                {
                    ty: 29,
                    nm: '高斯模糊',
                    np: 5,
                    mn: 'ADBE Gaussian Blur 2',
                    ix: 1,
                    en: 1,
                    ef: [
                        {
                            ty: 0,
                            nm: '模糊度',
                            mn: 'ADBE Gaussian Blur 2-0001',
                            ix: 1,
                            v: {a: 0, k: 5, ix: 1},
                        },
                        {
                            ty: 7,
                            nm: '模糊方向',
                            mn: 'ADBE Gaussian Blur 2-0002',
                            ix: 2,
                            v: {a: 0, k: 1, ix: 2},
                        },
                        {
                            ty: 7,
                            nm: '重复边缘像素',
                            mn: 'ADBE Gaussian Blur 2-0003',
                            ix: 3,
                            v: {a: 0, k: 1, ix: 3},
                        },
                    ],
                },
            ],
            shapes: [
                {
                    ty: 'gr',
                    it: [
                        {
                            d: 1,
                            ty: 'el',
                            s: {a: 0, k: [5.68, 5.68], ix: 2},
                            p: {a: 0, k: [0, 0], ix: 3},
                            nm: '椭圆路径 1',
                            mn: 'ADBE Vector Shape - Ellipse',
                            hd: false,
                        },
                        {
                            ty: 'pb',
                            nm: '收缩和膨胀 1',
                            a: {a: 0, k: -40, ix: 1},
                            ix: 2,
                            mn: 'ADBE Vector Filter - PB',
                            hd: false,
                        },
                        {
                            ty: 'fl',
                            c: {a: 0, k: [1, 1, 1, 1], ix: 4},
                            o: {a: 0, k: 100, ix: 5},
                            r: 1,
                            bm: 0,
                            nm: '填充 1',
                            mn: 'ADBE Vector Graphic - Fill',
                            hd: false,
                        },
                        {
                            ty: 'tr',
                            p: {a: 0, k: [-543.91, -342.16], ix: 2},
                            a: {a: 0, k: [0, 0], ix: 1},
                            s: {a: 0, k: [100, 100], ix: 3},
                            r: {a: 0, k: 0, ix: 6},
                            o: {a: 0, k: 100, ix: 7},
                            sk: {a: 0, k: 0, ix: 4},
                            sa: {a: 0, k: 0, ix: 5},
                            nm: '变换',
                        },
                    ],
                    nm: '椭圆 1',
                    np: 4,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: 'ADBE Vector Group',
                    hd: false,
                },
            ],
            ip: 19,
            op: 306,
            st: 0,
            bm: 0,
        },
        {
            ddd: 0,
            ind: 2,
            ty: 4,
            nm: '形状图层 3',
            sr: 1,
            ks: {
                o: {a: 0, k: 100, ix: 11},
                r: {a: 0, k: 0, ix: 10},
                p: {a: 0, k: [252.09, 267.84, 0], ix: 2, l: 2},
                a: {a: 0, k: [-543.91, -342.16, 0], ix: 1, l: 2},
                s: {
                    a: 1,
                    k: [
                        {
                            i: {x: [0.667, 0.667, 0.667], y: [1, 1, 1]},
                            o: {x: [0.333, 0.333, 0.333], y: [0, 0, 0]},
                            t: 30,
                            s: [20, 20, 100],
                        },
                        {
                            i: {x: [0.667, 0.667, 0.667], y: [1, 1, 1]},
                            o: {x: [0.333, 0.333, 0.333], y: [0, 0, 0]},
                            t: 40,
                            s: [120, 120, 100],
                        },
                        {t: 80, s: [20, 20, 100]},
                    ],
                    ix: 6,
                    l: 2,
                },
            },
            ao: 0,
            ef: [
                {
                    ty: 29,
                    nm: '高斯模糊',
                    np: 5,
                    mn: 'ADBE Gaussian Blur 2',
                    ix: 1,
                    en: 1,
                    ef: [
                        {
                            ty: 0,
                            nm: '模糊度',
                            mn: 'ADBE Gaussian Blur 2-0001',
                            ix: 1,
                            v: {a: 0, k: 5, ix: 1},
                        },
                        {
                            ty: 7,
                            nm: '模糊方向',
                            mn: 'ADBE Gaussian Blur 2-0002',
                            ix: 2,
                            v: {a: 0, k: 1, ix: 2},
                        },
                        {
                            ty: 7,
                            nm: '重复边缘像素',
                            mn: 'ADBE Gaussian Blur 2-0003',
                            ix: 3,
                            v: {a: 0, k: 1, ix: 3},
                        },
                    ],
                },
            ],
            shapes: [
                {
                    ty: 'gr',
                    it: [
                        {
                            d: 1,
                            ty: 'el',
                            s: {a: 0, k: [5.68, 5.68], ix: 2},
                            p: {a: 0, k: [0, 0], ix: 3},
                            nm: '椭圆路径 1',
                            mn: 'ADBE Vector Shape - Ellipse',
                            hd: false,
                        },
                        {
                            ty: 'pb',
                            nm: '收缩和膨胀 1',
                            a: {a: 0, k: -40, ix: 1},
                            ix: 2,
                            mn: 'ADBE Vector Filter - PB',
                            hd: false,
                        },
                        {
                            ty: 'fl',
                            c: {a: 0, k: [1, 1, 1, 1], ix: 4},
                            o: {a: 0, k: 100, ix: 5},
                            r: 1,
                            bm: 0,
                            nm: '填充 1',
                            mn: 'ADBE Vector Graphic - Fill',
                            hd: false,
                        },
                        {
                            ty: 'tr',
                            p: {a: 0, k: [-543.91, -342.16], ix: 2},
                            a: {a: 0, k: [0, 0], ix: 1},
                            s: {a: 0, k: [100, 100], ix: 3},
                            r: {a: 0, k: 0, ix: 6},
                            o: {a: 0, k: 100, ix: 7},
                            sk: {a: 0, k: 0, ix: 4},
                            sa: {a: 0, k: 0, ix: 5},
                            nm: '变换',
                        },
                    ],
                    nm: '椭圆 1',
                    np: 4,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: 'ADBE Vector Group',
                    hd: false,
                },
            ],
            ip: 19,
            op: 306,
            st: 5,
            bm: 0,
        },
        {
            ddd: 0,
            ind: 3,
            ty: 4,
            nm: '形状图层 19',
            sr: 1,
            ks: {
                o: {a: 0, k: 100, ix: 11},
                r: {a: 0, k: 0, ix: 10},
                p: {a: 0, k: [72.09, 147.84, 0], ix: 2, l: 2},
                a: {a: 0, k: [-543.91, -342.16, 0], ix: 1, l: 2},
                s: {
                    a: 1,
                    k: [
                        {
                            i: {x: [0.667, 0.667, 0.667], y: [1, 1, 1]},
                            o: {x: [0.333, 0.333, 0.333], y: [0, 0, 0]},
                            t: 64,
                            s: [20, 20, 100],
                        },
                        {
                            i: {x: [0.667, 0.667, 0.667], y: [1, 1, 1]},
                            o: {x: [0.333, 0.333, 0.333], y: [0, 0, 0]},
                            t: 74,
                            s: [150, 150, 100],
                        },
                        {t: 114, s: [20, 20, 100]},
                    ],
                    ix: 6,
                    l: 2,
                },
            },
            ao: 0,
            ef: [
                {
                    ty: 29,
                    nm: '高斯模糊',
                    np: 5,
                    mn: 'ADBE Gaussian Blur 2',
                    ix: 1,
                    en: 1,
                    ef: [
                        {
                            ty: 0,
                            nm: '模糊度',
                            mn: 'ADBE Gaussian Blur 2-0001',
                            ix: 1,
                            v: {a: 0, k: 0, ix: 1},
                        },
                        {
                            ty: 7,
                            nm: '模糊方向',
                            mn: 'ADBE Gaussian Blur 2-0002',
                            ix: 2,
                            v: {a: 0, k: 1, ix: 2},
                        },
                        {
                            ty: 7,
                            nm: '重复边缘像素',
                            mn: 'ADBE Gaussian Blur 2-0003',
                            ix: 3,
                            v: {a: 0, k: 1, ix: 3},
                        },
                    ],
                },
            ],
            shapes: [
                {
                    ty: 'gr',
                    it: [
                        {
                            d: 1,
                            ty: 'el',
                            s: {a: 0, k: [5.68, 5.68], ix: 2},
                            p: {a: 0, k: [0, 0], ix: 3},
                            nm: '椭圆路径 1',
                            mn: 'ADBE Vector Shape - Ellipse',
                            hd: false,
                        },
                        {
                            ty: 'pb',
                            nm: '收缩和膨胀 1',
                            a: {a: 0, k: -40, ix: 1},
                            ix: 2,
                            mn: 'ADBE Vector Filter - PB',
                            hd: false,
                        },
                        {
                            ty: 'fl',
                            c: {a: 0, k: [1, 1, 1, 1], ix: 4},
                            o: {a: 0, k: 100, ix: 5},
                            r: 1,
                            bm: 0,
                            nm: '填充 1',
                            mn: 'ADBE Vector Graphic - Fill',
                            hd: false,
                        },
                        {
                            ty: 'tr',
                            p: {a: 0, k: [-543.91, -342.16], ix: 2},
                            a: {a: 0, k: [0, 0], ix: 1},
                            s: {a: 0, k: [100, 100], ix: 3},
                            r: {a: 0, k: 0, ix: 6},
                            o: {a: 0, k: 100, ix: 7},
                            sk: {a: 0, k: 0, ix: 4},
                            sa: {a: 0, k: 0, ix: 5},
                            nm: '变换',
                        },
                    ],
                    nm: '椭圆 1',
                    np: 4,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: 'ADBE Vector Group',
                    hd: false,
                },
            ],
            ip: 19,
            op: 306,
            st: 39,
            bm: 0,
        },
        {
            ddd: 0,
            ind: 4,
            ty: 4,
            nm: '形状图层 2',
            sr: 1,
            ks: {
                o: {a: 0, k: 100, ix: 11},
                r: {a: 0, k: 0, ix: 10},
                p: {a: 0, k: [292.09, 87.84, 0], ix: 2, l: 2},
                a: {a: 0, k: [-543.91, -342.16, 0], ix: 1, l: 2},
                s: {
                    a: 1,
                    k: [
                        {
                            i: {x: [0.667, 0.667, 0.667], y: [1, 1, 1]},
                            o: {x: [0.333, 0.333, 0.333], y: [0, 0, 0]},
                            t: 48,
                            s: [20, 20, 100],
                        },
                        {
                            i: {x: [0.667, 0.667, 0.667], y: [1, 1, 1]},
                            o: {x: [0.333, 0.333, 0.333], y: [0, 0, 0]},
                            t: 58,
                            s: [100, 100, 100],
                        },
                        {t: 98, s: [20, 20, 100]},
                    ],
                    ix: 6,
                    l: 2,
                },
            },
            ao: 0,
            ef: [
                {
                    ty: 29,
                    nm: '高斯模糊',
                    np: 5,
                    mn: 'ADBE Gaussian Blur 2',
                    ix: 1,
                    en: 1,
                    ef: [
                        {
                            ty: 0,
                            nm: '模糊度',
                            mn: 'ADBE Gaussian Blur 2-0001',
                            ix: 1,
                            v: {a: 0, k: 5, ix: 1},
                        },
                        {
                            ty: 7,
                            nm: '模糊方向',
                            mn: 'ADBE Gaussian Blur 2-0002',
                            ix: 2,
                            v: {a: 0, k: 1, ix: 2},
                        },
                        {
                            ty: 7,
                            nm: '重复边缘像素',
                            mn: 'ADBE Gaussian Blur 2-0003',
                            ix: 3,
                            v: {a: 0, k: 1, ix: 3},
                        },
                    ],
                },
            ],
            shapes: [
                {
                    ty: 'gr',
                    it: [
                        {
                            d: 1,
                            ty: 'el',
                            s: {a: 0, k: [5.68, 5.68], ix: 2},
                            p: {a: 0, k: [0, 0], ix: 3},
                            nm: '椭圆路径 1',
                            mn: 'ADBE Vector Shape - Ellipse',
                            hd: false,
                        },
                        {
                            ty: 'pb',
                            nm: '收缩和膨胀 1',
                            a: {a: 0, k: -40, ix: 1},
                            ix: 2,
                            mn: 'ADBE Vector Filter - PB',
                            hd: false,
                        },
                        {
                            ty: 'fl',
                            c: {a: 0, k: [1, 1, 1, 1], ix: 4},
                            o: {a: 0, k: 100, ix: 5},
                            r: 1,
                            bm: 0,
                            nm: '填充 1',
                            mn: 'ADBE Vector Graphic - Fill',
                            hd: false,
                        },
                        {
                            ty: 'tr',
                            p: {a: 0, k: [-543.91, -342.16], ix: 2},
                            a: {a: 0, k: [0, 0], ix: 1},
                            s: {a: 0, k: [100, 100], ix: 3},
                            r: {a: 0, k: 0, ix: 6},
                            o: {a: 0, k: 100, ix: 7},
                            sk: {a: 0, k: 0, ix: 4},
                            sa: {a: 0, k: 0, ix: 5},
                            nm: '变换',
                        },
                    ],
                    nm: '椭圆 1',
                    np: 4,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: 'ADBE Vector Group',
                    hd: false,
                },
            ],
            ip: 19,
            op: 306,
            st: 23,
            bm: 0,
        },
    ],
    markers: [],
};
